import { Component } from '@angular/core';

@Component({
  selector: 'app-multimedia-production',
  templateUrl: './multimedia-production.component.html',
  styleUrls: ['./multimedia-production.component.scss']
})
export class MultimediaProductionComponent {

}
